<template>
  <div class="inner-content">
    <div class="scroll-box">
      <img v-if="prizeUrl" class="center" :src="prizeUrl" @load="loaded = true" alt="" />
      <div v-if="!loaded" class="loading"><span class="spinner"></span></div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useConfig } from '@/composables/useConfig'

defineOptions({ name: 'PrizeAmount' })

const config = useConfig()
const prizeUrl = computed(() => config.value?.prize || '')

const loaded = ref(false)
</script>


<style lang="scss" scoped>
.inner-content {
  width: 967px;
  height: 504px;
  margin: 12px 0 0 7.5px;
  position: relative;

  .scroll-box {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    white-space: pre-line;

    .center {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  .loading {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;

    .spinner {
      width: 40px;
      height: 40px;
      border: 4px solid rgba(137, 0, 2, 0.15);
      border-top-color: #890002;
      border-radius: 50%;
      animation: ui-modal-spin 0.8s linear infinite;
    }
  }
}

@keyframes ui-modal-spin {
  to { transform: rotate(360deg); }
}
</style>
